import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
   selector: 'mnf-modal-mfa',
   templateUrl: './modal-mfa.component.html',
   styleUrls: ['./modal-mfa.component.scss']
})
export class ModalMfaComponent {

   tokenForm = new FormGroup({
      token: new FormControl('', [Validators.required, Validators.minLength(5)])
   });

   constructor(private dialog: MatDialogRef<ModalMfaComponent, string>) { }

   next() {
      if (this.tokenForm.valid) {
         this.dialog.close(this.tokenForm.controls.token.value);
      }
   }

   close() {
      this.dialog.close();
   }

}
